export const initialStateFilter = {
    status: '',
    periodoFinal: '',
    periodoInicial: '',
    ufDetran: '',
    possuiImagem: '',
    chassi: '',
    numeroGravame: '',
    numeroContrato: '',
    tipoOperacao: ''
}
